import "./polyfills";
import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import App from "./App";
import { GameProvider } from "./context/GameContext";
import { PlatformAuthProvider } from "./context/AuthContext";
import MultiplayerProvider from "./context/MultiplayerContext";
import { DeviceProvider } from "./context/DeviceContext";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
    <StrictMode>
        <DeviceProvider>
            <GameProvider>
                <MultiplayerProvider>
                    <PlatformAuthProvider>
                        <App data-testid="app" />
                    </PlatformAuthProvider>
                </MultiplayerProvider>
            </GameProvider>
        </DeviceProvider>
    </StrictMode>,
);
